import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/jqr2.png';
import _imports_1 from '../../public/img/close.png';
import _imports_2 from '../../public/img/laba.png';
const _withScopeId = n => (_pushScopeId("data-v-3c608a9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "20px"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "css6"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "position": "absolute",
    "left": "-30px"
  }
}), /*#__PURE__*/_createTextVNode(" 我已经为你分析了所有句子，点击确认你要分析的语句 ")], -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 1,
  style: {
    "margin-top": "1rem"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "css6"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "position": "absolute",
    "left": "-30px"
  }
}), /*#__PURE__*/_createTextVNode(" 小提示：点击具体单词可以查询解释，如果有红色词条，那就是这个词在本句中的唯一解释。 ")], -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 1,
  style: {
    "font-weight": "700",
    "padding-top": "20px"
  }
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#333333"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "padding": "5px"
  }
}, " AI老师分析中... ")], -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 2,
  style: {
    "font-weight": "700",
    "padding-top": "20px"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#333333"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "padding": "5px"
  }
}, " AI老师分析完毕 ")], -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  style: {
    "background": "#e7f6ff",
    "border": "1px solid #0086f0",
    "border-radius": "16px",
    "padding": "20px",
    "color": "#032b72",
    "font-size": "17px",
    "margin-top": "60px",
    "position": "relative"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "position": "absolute",
    "left": "-15px",
    "top": "-40px"
  }
}, null, -1));
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  class: "flex"
};
const _hoisted_22 = {
  style: {
    "width": "85%",
    "padding-left": "5px",
    "padding-top": "5px",
    "word-break": "break-all"
  }
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "20px",
    "height": "20px"
  }
}, null, -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "2px",
    "background-color": "#ccc",
    "margin-top": "3px"
  }
}, null, -1));
const _hoisted_26 = {
  style: {
    "height": "20px"
  },
  class: "flex align-center"
};
const _hoisted_27 = {
  key: 0,
  style: {
    "color": "#485860",
    "margin-left": "5px"
  }
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "margin-left": "5px",
    "width": "15px",
    "height": "15px"
  }
}, null, -1));
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = {
  key: 1,
  style: {
    "margin-left": "5px",
    "font-size": "12px"
  }
};
const _hoisted_31 = {
  style: {
    "margin-top": "5px",
    "margin-bottom": "5px",
    "margin-left": "5px"
  }
};
const _hoisted_32 = {
  style: {
    "text-align": "left",
    "width": "fit-content"
  }
};
const _hoisted_33 = {
  key: 0,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "violet"
  }
};
const _hoisted_34 = {
  key: 1,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#fad960"
  }
};
const _hoisted_35 = {
  key: 0,
  style: {
    "font-style": "italic"
  }
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "2px",
    "background-color": "#ccc",
    "margin-top": "3px"
  }
}, null, -1));
const _hoisted_37 = {
  style: {
    "margin-left": "5px",
    "margin-right": "5px"
  }
};
const _hoisted_38 = {
  style: {
    "width": "90%",
    "padding-left": "5px",
    "padding-top": "5px"
  }
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原型:", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_42 = {
  key: 0,
  style: {
    "color": "#485860"
  }
};
const _hoisted_43 = {
  style: {
    "text-align": "left",
    "width": "fit-content"
  }
};
const _hoisted_44 = {
  key: 0,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "violet"
  }
};
const _hoisted_45 = {
  key: 1,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#fad960"
  }
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "10px"
  }
}, null, -1));
const _hoisted_47 = {
  key: 0,
  class: "position-relative",
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_48 = ["innerHTML"];
const _hoisted_49 = {
  key: 1,
  class: "flex align-center justify-center"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#333333",
    "font-weight": "700"
  }
}, " 点击查看下一步 ", -1));
const _hoisted_51 = [_hoisted_50];
const _hoisted_52 = {
  class: "text-center"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  key: 5,
  style: {
    "width": "100%"
  },
  class: "empty"
};
const _hoisted_55 = {
  key: 6,
  style: {
    "padding": "20px"
  }
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chinese",
  style: {
    "color": "#999"
  }
}, "中文释义", -1));
const _hoisted_57 = {
  class: "black",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_58 = {
  key: 0
};
const _hoisted_59 = {
  key: 0,
  style: {
    "margin-top": "40px",
    "color": "#2b9af3"
  },
  class: "black"
};
const _hoisted_60 = {
  key: 1,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_61 = {
  key: 2,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_62 = {
  key: 3,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_63 = {
  key: 4,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_64 = {
  key: 1
};
const _hoisted_65 = {
  style: {
    "margin-top": "40px"
  },
  class: "black"
};
const _hoisted_66 = {
  key: 0,
  style: {
    "margin-top": "20px",
    "color": "#2b9af3"
  },
  class: "black"
};
const _hoisted_67 = {
  key: 1,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_68 = {
  key: 2,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_69 = {
  key: 3,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_70 = {
  key: 4,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_71 = {
  key: 3
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "black",
  style: {
    "padding": "5px 0",
    "margin-top": "20px",
    "font-weight": "bold"
  }
}, " 选择本句包含的知识点： ", -1));
const _hoisted_73 = ["onClick"];
const _hoisted_74 = {
  style: {
    "font-size": "0.6rem",
    "font-style": "italic",
    "color": "#ddd255",
    "text-align": "right",
    "width": "fit-content",
    "float": "right"
  }
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_76 = {
  style: {
    "color": "#4c99a9",
    "margin-bottom": "5px",
    "font-weight": "bold"
  }
};
const _hoisted_77 = ["innerHTML"];
const _hoisted_78 = {
  style: {
    "color": "#4c99a9",
    "padding-bottom": "5px"
  }
};
const _hoisted_79 = ["innerHTML"];
const _hoisted_80 = {
  style: {
    "padding-bottom": "5px"
  }
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {
    "border-width": "0.001rem",
    "border-style": "dashed",
    "margin": "3px"
  }
}, null, -1));
const _hoisted_82 = {
  style: {
    "padding": "10px"
  }
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "10px"
  }
}, null, -1));
import { reactive, computed, ref, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { grammarAnalysis, bizTts, translate } from "../api/index";
export default {
  __name: 'analyse2',
  props: {
    queryTxt: {
      type: [String, Array],
      default: ""
    },
    articleId: {
      type: [String, Number],
      default: ""
    },
    readLogId: {
      type: [String, Number],
      default: ""
    }
  },
  setup(__props) {
    const store = useStore();
    const safeMes = computed(() => store.state.safeMes);
    const props = __props;
    const queryTxt = ref(props.queryTxt);
    const articleId = ref(props.articleId);
    const readLogId = ref(props.readLogId);
    const txt = ref("");
    let currentNode = null;
    const empty_vis = ref(true);
    let linshi = "";
    const bShowCefrWords = ref(false);
    const origSentence = ref("");
    const nowSentence = ref("");
    const inAnalyse = ref(false);
    const translation = ref("");
    const mSentType = ref("");
    const sub = ref("");
    const pred = ref("");
    const object = ref("");
    const prej = ref("");
    const isZWB = ref(true);
    const data = reactive({
      subLRlist: [],
      grammer: {},
      translationsV2: [],
      lemma: null,
      animationList: [],
      knowledgePoints2: [],
      knowledgeNames2: []
    });
    const popVis = ref(false); //单词的弹出层
    const word_top = ref(0);
    const clicked_word = ref(""); // 单词
    let linshiOffset = ""; // offset
    const audioUrl = ref("");
    const phonetic = ref("");
    let translations = [];
    const animationIndex = ref(0);
    const canPlay = ref(false);
    let odl = null;
    const knowledgeNamesGrade2 = reactive({});
    const activeKnowledgeName2 = ref("");
    const audio = ref([]);
    const next = () => {
      if (!canPlay.value) return;
      audio.value[0].play();
      canPlay.value = false;
    };
    //音频播放完毕 切换下一个
    const audioEnd = () => {
      animationIndex.value++;
      console.log(animationIndex.value, "播放第 条语音");
      canPlay.value = true;
    };
    // 获取音频
    const getSpeaker = () => {
      let obj = {
        ...safeMes.value,
        articleId: articleId.value,
        readLogId: readLogId.value,
        content: clicked_word.value
      };
      bizTts(encodeURIComponent(JSON.stringify(obj))).then(v => {
        const res = v.data;
        if (res.code) return store.commit("judgeCode", {
          code: res.code,
          msg: res.msg
        });
        audioUrl.value = res.data.audioUrl;
      }).catch(() => {
        ElMessage.error("获取音频失败");
      });
    };
    // 播放语音
    const toSpeak = () => {
      odl = new Audio();
      odl.src = audioUrl.value;
      odl.play();
    };
    // 得到翻译
    const getTranslate = () => {
      let obj = {
        ...safeMes.value,
        articleId: articleId.value,
        readLogId: readLogId.value,
        content: clicked_word.value,
        sentence: linshi,
        offset: linshiOffset
      };
      translate(encodeURIComponent(JSON.stringify(obj))).then(v => {
        const res = v.data;
        if (res.code) return store.commit("judgeCode", {
          code: res.code,
          msg: res.msg
        });
        data.lemma = res.data.wordResult.lemma;
        phonetic.value = res.data.wordResult.phonetic;
        translations = [];
        data.translationsV2 = res.data.wordResult.translationsV2;
        let index = 0;
        while (translations.length < res.data.wordResult.translations.length) {
          translations.push("");
          translations.splice(index, 1, res.data.wordResult.translations[index]);
          index++;
        }
        getSpeaker();
      }).catch(() => {
        ElMessage.error("翻译失败");
      });
    };

    // 弹出层
    const word_popup = e => {
      // 如果没用点击到dom或者点击的不是单词，就不执行
      if (!e.target || e.target.className.indexOf("word") === -1) return;
      if (currentNode) {
        currentNode.style.background = "inherit";
        currentNode.style.color = "inherit";
        currentNode = null;
      }
      currentNode = e.target;
      currentNode.style.background = "#83b2e1";
      currentNode.style.color = "#fff";
      const text = e.target.childNodes[0].nodeValue;
      linshiOffset = e.target.attributes["offset0"].nodeValue;
      clicked_word.value = (text || "").trim();
      getTranslate();
      console.log(clicked_word.value, "单词", linshiOffset, "offset");
      popVis.value = true;
      console.log(e);
      word_top.value = e.offsetY + 40;
    };
    //  返回到工具首页
    const back = () => {
      location.reload();
    };
    const castSentenceTypeName = sentType => {
      switch (sentType) {
        case "incomplete_sentence":
          return "句式结构不完整";
        case "general_question":
          return "一般疑问句";
        case "special_question":
          return "特殊疑问句";
        case "complete_inversion":
          return "完全倒装句";
        case "partial_inversion":
          return "部分倒装句";
        case "imperative":
          return "祈使句";
        case "declarative":
          return "陈述句";
        default:
          return "";
      }
    };
    //  详细分析
    const chooseHandler = content => {
      linshi = content;
      animationIndex.value = 0;
      origSentence.value = content;
      nowSentence.value = getHtml(content);
      console.log("", content);
      let obj = {
        ...safeMes.value,
        articleId: articleId.value ? articleId.value - 0 : 0,
        readLogId: readLogId.value ? readLogId.value - 0 : 0,
        content: content
      };
      inAnalyse.value = true;
      grammarAnalysis(encodeURIComponent(JSON.stringify(obj))).then(result => {
        console.log(result);
        if (result.code) return store.commit("judgeCode", {
          code: result.code,
          msg: result.msg
        });
        empty_vis.value = false;
        inAnalyse.value = false;
        let res = result.data.data.lineResults[0];
        translation.value = res.translation;
        // 主谓宾
        if (!res.subLRs.length) {
          mSentType.value = res.sentStruct.mSentType;
          sub.value = res.sentStruct.sub.word;
          pred.value = res.sentStruct.pred.word;
          object.value = res.sentStruct.obj.word;
          prej.value = res.sentStruct.prej.word;
          isZWB.value = res.sentStruct.isZWB;

          // 获取动画
          data.animationList = [...res.animation];
          canPlay.value = true;
          for (let i = 0; i < data.animationList.length; i++) {
            console.log(data.animationList[i].audio);
          }
        } else {
          while (data.subLRlist.length < res.subLRs.length) {
            data.subLRlist.push({});
          }
          for (let i = 0; i < res.subLRs.length; i++) {
            data.subLRlist.splice(i, 1, res.subLRs[i]);
          }
        }
        // 主谓宾
        // 年级
        let index = 0;
        for (let key in res.gradeGrammars) {
          if (!index) res.gradeGrammars[key].active = true;else res.gradeGrammars[key].active = false;
          index++;
          for (let i = 0; i < res.gradeGrammars[key].length; i++) {
            if (!i) res.gradeGrammars[key][i].active = false;else res.gradeGrammars[key][i].active = false;
          }
        }
        data.grammer = res.gradeGrammars;
        buildKnowledgePoints2();
      }).catch(err => {
        inAnalyse.value = false;
        console.log(err);
        return ElMessage.error("分析失败");
      });
    };
    const chooseAnother = () => {
      empty_vis.value = true;
      inAnalyse.value = false;
    };
    const getHtml = str => {
      return str.replace(/\b(\w+)\b/g, function (m, w, pos) {
        return `<span class="word" offset0="${pos}">${w}</span>`;
      });
    };
    const buildKnowledgePoints2 = () => {
      for (let grade in data.grammer) {
        //年级名称：小学一年级
        let grammarArr = data.grammer[grade]; //知识点数组
        for (let i = 0; i < grammarArr.length; i++) {
          let point = grammarArr[i]; //知识点对象
          point.grade = grade;
          data.knowledgePoints2.push(point);
        }
      }
      //sort: order by levelId desc
      data.knowledgePoints2.sort(function (a, b) {
        return b["levelId"] - a["levelId"];
      });

      //fill knowledgePoints2
      for (let i = 0; i < data.knowledgePoints2.length; i++) {
        let obj = data.knowledgePoints2[i];
        if (data.knowledgeNames2.indexOf(obj.name) < 0) {
          data.knowledgeNames2.push(obj.name);
          knowledgeNamesGrade2[obj.name] = obj.grade;
        }
      }
    };
    const changeKnowledgePointActive2 = knowledgePointName => {
      activeKnowledgeName2.value = knowledgePointName;
    };
    onMounted(() => {
      if (typeof queryTxt.value === "string") {
        txt.value = [queryTxt.value] || ["you can"];
      } else {
        txt.value = queryTxt.value || ["you can"];
      }
    });
    onBeforeUpdate(() => {
      audio.value = [];
    });
    return (_ctx, _cache) => {
      const _component_CefrWords = _resolveComponent("CefrWords");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [!inAnalyse.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [empty_vis.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), translation.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), inAnalyse.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), !animationIndex.value && data.animationList.length && canPlay.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_hoisted_16, empty_vis.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(txt.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => chooseHandler(item),
          key: index
        }, _toDisplayString(item), 9, _hoisted_18);
      }), 128))])) : _createCommentVNode("", true), !empty_vis.value && (animationIndex.value >= data.animationList.length || animationIndex.value == 0) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: {
          "font-size": "18px",
          "color": "#666"
        },
        onClick: word_popup,
        class: "html-box",
        innerHTML: nowSentence.value
      }, null, 8, _hoisted_19)) : _createCommentVNode("", true), !empty_vis.value && animationIndex.value < data.animationList.length && animationIndex.value >= 1 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        style: {
          "padding": "20px",
          "font-size": "18px",
          "color": "#666"
        },
        class: "html-box",
        innerHTML: data.animationList[animationIndex.value - 1].markLine
      }, null, 8, _hoisted_20)) : _createCommentVNode("", true), popVis.value ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        style: _normalizeStyle([{
          "position": "absolute",
          "left": "50%",
          "width": "96%",
          "background-color": "#2b85e4",
          "color": "white",
          "border-radius": "5px",
          "transform": "translateX(-50%)"
        }, 'top:' + word_top.value + 'px;'])
      }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(clicked_word.value), 1), _createElementVNode("div", {
        style: {
          "z-index": "15",
          "width": "15%",
          "font-size": "24px",
          "font-weight": "700",
          "color": "white",
          "text-align": "center",
          "padding-right": "10px"
        },
        onClick: _cache[0] || (_cache[0] = $event => popVis.value = false)
      }, _hoisted_24)]), _hoisted_25, _createElementVNode("div", _hoisted_26, [phonetic.value ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString("[ " + phonetic.value + " ]"), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
        onClick: toSpeak,
        style: {
          "width": "40px",
          "height": "20px",
          "display": "flex",
          "align-items": "center"
        }
      }, _hoisted_29), !audioUrl.value ? (_openBlock(), _createElementBlock("span", _hoisted_30, " 加载中... ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.translationsV2, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "border-bottom-color": "#58a6e3",
            "border-bottom-style": "dashed",
            "border-bottom-width": "0.05rem",
            "padding": "1px"
          }
        }, [_createElementVNode("div", _hoisted_32, [item.isVariant ? (_openBlock(), _createElementBlock("span", _hoisted_33, "↓词性要点")) : item.bestIndexes.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "↓最佳解释")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("span", {
          style: _normalizeStyle(item.bestIndexes.length > 0 ? 'color: #fad960;' : '')
        }, _toDisplayString(item.pos), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.explains, (explain, idxL2) => {
          return _openBlock(), _createElementBlock("span", {
            key: idxL2
          }, [idxL2 > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(",")], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
            style: _normalizeStyle(item.isVariant ? 'color:violet;' : item.bestIndexes.indexOf(idxL2) != -1 ? 'color: #fad960;' : '')
          }, _toDisplayString(explain), 5)]);
        }), 128))])]);
      }), 128))]), data.lemma ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _hoisted_40, _createElementVNode("span", null, _toDisplayString(data.lemma.word), 1), _hoisted_41, data.lemma.phonetic ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString("[ " + data.lemma.phonetic + " ]"), 1)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.lemma.translationsV2, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "border-bottom-color": "#58a6e3",
            "border-bottom-style": "dashed",
            "border-bottom-width": "0.05rem",
            "padding": "1px"
          }
        }, [_createElementVNode("div", _hoisted_43, [item.isVariant ? (_openBlock(), _createElementBlock("span", _hoisted_44, "↓词性要点")) : item.bestIndexes.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_45, "↓最佳解释")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("span", {
          style: _normalizeStyle(item.bestIndexes.length > 0 ? 'color: #fad960;' : '')
        }, _toDisplayString(item.pos), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.explains, (explain, idxL2) => {
          return _openBlock(), _createElementBlock("span", {
            key: idxL2
          }, [idxL2 > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(",")], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
            style: _normalizeStyle(item.isVariant ? 'color:violet;' : item.bestIndexes.indexOf(idxL2) != -1 ? 'color: #fad960;' : '')
          }, _toDisplayString(explain), 5)]);
        }), 128))])]);
      }), 128))])])) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true), _hoisted_46, canPlay.value && data.animationList.length && animationIndex.value < data.animationList.length ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "",
        style: {
          "position": "fixed",
          "left": "0",
          "right": "0",
          "top": "0",
          "bottom": "0",
          "z-index": "10",
          "background-color": "rgba(0, 0, 0, 0)"
        },
        onClick: next
      })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.animationList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [index == animationIndex.value ? (_openBlock(), _createElementBlock("div", _hoisted_47, [!(canPlay.value && !animationIndex.value) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "html-box",
          style: {
            "margin": "5px",
            "padding": "0 5px 5px 5px",
            "width": "100%"
          },
          innerHTML: item.text
        }, null, 8, _hoisted_48)) : _createCommentVNode("", true), animationIndex.value < data.animationList.length && animationIndex.value >= 1 && canPlay.value ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_52, [_createElementVNode("audio", {
          onEnded: audioEnd,
          src: item.audio,
          ref_for: true,
          ref: el => {
            if (el) audio.value[_ctx.i] = el;
          }
        }, null, 40, _hoisted_53)])])) : _createCommentVNode("", true)]);
      }), 128)), empty_vis.value ? (_openBlock(), _createElementBlock("div", _hoisted_54)) : _createCommentVNode("", true), !empty_vis.value && animationIndex.value >= data.animationList.length ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, _toDisplayString(translation.value), 1), !data.subLRlist.length ? (_openBlock(), _createElementBlock("div", _hoisted_58, [mSentType.value ? (_openBlock(), _createElementBlock("div", _hoisted_59, " 本句为: " + _toDisplayString(castSentenceTypeName(mSentType.value)), 1)) : _createCommentVNode("", true), sub.value ? (_openBlock(), _createElementBlock("div", _hoisted_60, " 主语: " + _toDisplayString(sub.value), 1)) : _createCommentVNode("", true), pred.value ? (_openBlock(), _createElementBlock("div", _hoisted_61, [isZWB.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("谓语: ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("系动词: ")], 64)), _createTextVNode(" " + _toDisplayString(pred.value), 1)])) : _createCommentVNode("", true), object.value ? (_openBlock(), _createElementBlock("div", _hoisted_62, " 宾语: " + _toDisplayString(object.value), 1)) : _createCommentVNode("", true), prej.value ? (_openBlock(), _createElementBlock("div", _hoisted_63, " 表语: " + _toDisplayString(prej.value), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_64, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.subLRlist, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_65, " 并列句" + _toDisplayString(index + 1) + ": " + _toDisplayString(item.origLine), 1), item.sentStruct.mSentType ? (_openBlock(), _createElementBlock("div", _hoisted_66, " 本句为: " + _toDisplayString(castSentenceTypeName(item.sentStruct.mSentType)), 1)) : _createCommentVNode("", true), item.sentStruct.sub.word ? (_openBlock(), _createElementBlock("div", _hoisted_67, " 主语: " + _toDisplayString(item.sentStruct.sub.word), 1)) : _createCommentVNode("", true), item.sentStruct.pred.word ? (_openBlock(), _createElementBlock("div", _hoisted_68, [item.sentStruct.isZWB ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode("谓语: ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode("系动词: ")], 64)), _createTextVNode(" " + _toDisplayString(item.sentStruct.pred.word), 1)])) : _createCommentVNode("", true), item.sentStruct.obj.word ? (_openBlock(), _createElementBlock("div", _hoisted_69, " 宾语: " + _toDisplayString(item.sentStruct.obj.word), 1)) : _createCommentVNode("", true), item.sentStruct.prej.word ? (_openBlock(), _createElementBlock("div", _hoisted_70, " 表语: " + _toDisplayString(item.sentStruct.prej.word), 1)) : _createCommentVNode("", true)]);
      }), 128))])), _createElementVNode("div", {
        class: "flex align-center",
        style: {
          "justify-content": "space-between",
          "margin-top": "40px"
        }
      }, [_createElementVNode("div", {
        style: {
          "color": "#fee096"
        },
        class: "buttons flex align-center justify-center",
        onClick: chooseAnother
      }, " 返回换一句 "), _createElementVNode("div", {
        style: {
          "color": "#fee096"
        },
        class: "buttons flex align-center justify-center",
        onClick: back
      }, " 返回工具首页 ")])])) : _createCommentVNode("", true)]), !empty_vis.value && animationIndex.value >= data.animationList.length ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_hoisted_72, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.knowledgeNames2, (name, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: 'point-name-' + idx,
          style: {
            "margin": "5px"
          },
          class: _normalizeClass(["inline-block", activeKnowledgeName2.value == name ? 'active' : 'bg-dec']),
          onClick: $event => changeKnowledgePointActive2(name)
        }, [_createElementVNode("div", null, _toDisplayString(name), 1), _createElementVNode("div", _hoisted_74, _toDisplayString(knowledgeNamesGrade2[name]), 1)], 10, _hoisted_73);
      }), 128)), _hoisted_75, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.knowledgePoints2, (item, idx) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.name == activeKnowledgeName2.value ? (_openBlock(), _createElementBlock("div", {
          key: 'point-value-' + idx,
          style: {
            "padding": "5px"
          }
        }, [_createElementVNode("div", _hoisted_76, _toDisplayString(item.name), 1), _createElementVNode("div", {
          style: {
            "margin-bottom": "5px"
          },
          class: "html-box",
          innerHTML: item.markLine
        }, null, 8, _hoisted_77), _createElementVNode("div", _hoisted_78, [_createElementVNode("span", {
          class: "html-box",
          innerHTML: item.description
        }, null, 8, _hoisted_79)]), _createElementVNode("div", _hoisted_80, _toDisplayString(item.sample), 1), _hoisted_81])) : _createCommentVNode("", true)], 64);
      }), 256))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_82, [_createElementVNode("button", {
        class: "active",
        style: {
          "background": "rgb(72,116,203)",
          "margin": "auto"
        },
        onClick: _cache[1] || (_cache[1] = $event => bShowCefrWords.value = !bShowCefrWords.value)
      }, _toDisplayString(bShowCefrWords.value ? '隐藏单词列表' : '查看单词列表'), 1), bShowCefrWords.value && origSentence.value ? (_openBlock(), _createBlock(_component_CefrWords, {
        key: 0,
        sentence: origSentence.value
      }, null, 8, ["sentence"])) : _createCommentVNode("", true)])]), _hoisted_83]);
    };
  }
};